import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonFab,
  IonFabButton,
  IonIcon,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { alertSharp } from 'ionicons/icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-app-puzzle-desktop-mode-warning',
  templateUrl: './puzzle-desktop-mode-warning.component.html',
  styleUrls: ['./puzzle-desktop-mode-warning.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonFab,
    IonFabButton,
    IonIcon,
    TranslateModule,
  ],
})
export class PuzzleDesktopModeWarningComponent {
  constructor() {
    addIcons({ alertSharp });
  }
}
